import React, { useState, useEffect } from 'react';
import { Box, Heading, FormControl, FormLabel, Input, Button, Alert, AlertIcon, VStack, Divider } from '@chakra-ui/react';
import { useAuth, logout, setUsuarioCache } from '../hooks/useAuth';
import { api } from '../services/api';
import { useNavigate } from 'react-router-dom';

const Profile: React.FC = () => {
  const { user } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setEmail(user.email || '');
      setName(user.nome || '');
    }
  }, [user]);

  const handleUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      const { user: atualizado } = await api.put('/api/auth/profile', { nome: name });
      setUsuarioCache(atualizado);
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao atualizar');
    }
    setLoading(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setPasswordError(null);
    setPasswordSuccess(false);
    if (!password || password.length < 6) {
      setPasswordError('A nova senha deve ter pelo menos 6 caracteres.');
      return;
    }
    if (password !== confirmPassword) {
      setPasswordError('As senhas não coincidem.');
      return;
    }
    try {
      await api.put('/api/auth/password', { password });
      setPasswordSuccess(true);
      setPassword('');
      setConfirmPassword('');
    } catch (err) {
      setPasswordError(err instanceof Error ? err.message : 'Erro ao alterar senha');
    }
  };

  return (
    <Box maxW="400px" mx="auto" mt={10} p={{ base: 5, md: 8 }} pb={{ base: 24, md: 8 }} borderRadius="lg" boxShadow="lg">
      <Heading size="lg" mb={6} textAlign="center">Perfil do Usuário</Heading>
      <form onSubmit={handleUpdate}>
        <VStack spacing={4}>
          {error && <Alert status="error" borderRadius="md"><AlertIcon />{error}</Alert>}
          {success && <Alert status="success" borderRadius="md"><AlertIcon />Nome atualizado com sucesso!</Alert>}
          <FormControl>
            <FormLabel>Nome</FormLabel>
            <Input value={name} onChange={e => setName(e.target.value)} placeholder="Seu nome" />
          </FormControl>
          <FormControl>
            <FormLabel>Email</FormLabel>
            <Box p={2} borderRadius="md" bg="gray.50" color="gray.700" fontSize="md" wordBreak="break-all">
              {email}
            </Box>
          </FormControl>
          <Button type="submit" colorScheme="teal" isLoading={loading} isDisabled={loading}>Salvar</Button>
        </VStack>
      </form>
      <Divider my={6} />
      <form onSubmit={handleChangePassword}>
        <VStack spacing={4}>
          <Heading size="md" mb={2} textAlign="center">Alterar Senha</Heading>
          {passwordError && <Alert status="error" borderRadius="md"><AlertIcon />{passwordError}</Alert>}
          {passwordSuccess && <Alert status="success" borderRadius="md"><AlertIcon />Senha alterada com sucesso!</Alert>}
          <FormControl>
            <FormLabel>Nova senha</FormLabel>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Nova senha" />
          </FormControl>
          <FormControl>
            <FormLabel>Confirmar nova senha</FormLabel>
            <Input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirme a nova senha" />
          </FormControl>
          <Button type="submit" colorScheme="teal">Alterar senha</Button>
        </VStack>
      </form>
      <Divider my={6} />
      <Button colorScheme="red" width="100%" onClick={handleLogout} mt={2} mb={{ base: 24, md: 0 }}>
        Sair
      </Button>
    </Box>
  );
};

export default Profile; 